// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.style_container__WVPZd {
  box-sizing: border-box;
  display: flex;
  flex-direction: column;
  height: 100%;
  width: 100%;
  padding: 25px 80px;

  @media (max-width: 1024px) {
    padding: 20px;
  }
}

.style_header__ei8Im {
  display: flex;
  align-items: center;
  justify-content: space-between;
  width: 100%;
  margin-bottom: 25px;
  gap: 1rem;
}

.style_headerTitle__\\+zBx9 {
  @media (max-width: 550px) {
    font-size: 1.2rem !important;
  }
}

.style_headerSubtitle__rOblq {
  @media (max-width: 550px) {
    display: none;
  }
}
`, "",{"version":3,"sources":["webpack://./src/pages/MaintenanceTypes/style.module.css"],"names":[],"mappings":"AAAA;EACE,sBAAsB;EACtB,aAAa;EACb,sBAAsB;EACtB,YAAY;EACZ,WAAW;EACX,kBAAkB;;EAElB;IACE,aAAa;EACf;AACF;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,8BAA8B;EAC9B,WAAW;EACX,mBAAmB;EACnB,SAAS;AACX;;AAEA;EACE;IACE,4BAA4B;EAC9B;AACF;;AAEA;EACE;IACE,aAAa;EACf;AACF","sourcesContent":[".container {\n  box-sizing: border-box;\n  display: flex;\n  flex-direction: column;\n  height: 100%;\n  width: 100%;\n  padding: 25px 80px;\n\n  @media (max-width: 1024px) {\n    padding: 20px;\n  }\n}\n\n.header {\n  display: flex;\n  align-items: center;\n  justify-content: space-between;\n  width: 100%;\n  margin-bottom: 25px;\n  gap: 1rem;\n}\n\n.headerTitle {\n  @media (max-width: 550px) {\n    font-size: 1.2rem !important;\n  }\n}\n\n.headerSubtitle {\n  @media (max-width: 550px) {\n    display: none;\n  }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"container": `style_container__WVPZd`,
	"header": `style_header__ei8Im`,
	"headerTitle": `style_headerTitle__+zBx9`,
	"headerSubtitle": `style_headerSubtitle__rOblq`
};
export default ___CSS_LOADER_EXPORT___;
